<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-button v-if="validarPermisoComponente('empresa-editar-campos-personalizados')" variant="primary"
                  class="float-right mb-2"
                  @click="_mostrarModalCampos('Crear')"
        >
        <i class="fa fa-plus"></i>
          Crear
        </b-button>
      </b-col>

      <b-col>
        <table v-if="listadoCamposPersonalizados.length > 0"
               class="table table-bordered table-striped table-sm"
               style="background-color:white;"
        >
          <thead>
          <tr class="table-active">
            <th>Nombre campo</th>
            <th style="width:100px;">Estado</th>
            <th v-if="validarPermisoComponente('empresa-editar-campos-personalizados')" style="width:100px;">Acciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(campopersonalizado,idx) in listadoCamposPersonalizados"
              :key="idx"
          >
            <td>{{ campopersonalizado.nombre }}</td>
            <td class="text-center">
              <b-badge v-if="!!campopersonalizado.activo"
                       variant="primary"
                       v-text="'Activo'"
              />
              <b-badge v-else
                       variant="danger"
                       v-text="'Inactivo'"
              />
            </td>
            <td v-if="validarPermisoComponente('empresa-editar-campos-personalizados')" class="text-center">
              <a v-b-tooltip.hover
                 class="botonProduct text-dark mr-3"
                 title="Editar"
                 @click="_getCamposPersonalizado(campopersonalizado)"
              >
                <i class="fa fa-edit"></i>
              </a>
              <a v-b-tooltip.hover
                 class="botonProduct"
                 :title="!!campopersonalizado.activo ? 'Inactivar' : 'Activar'"
                 @click="_cambiarEstado(campopersonalizado)"
              >
                <i class="fa fa-close text-danger"
                   v-if="!!campopersonalizado.activo"
                />
                <i class="fa fa-check text-success"
                   v-else
                />
              </a>
            </td>
          </tr>
          </tbody>
        </table>

      </b-col>

      <b-modal v-model="modal_campos_personalizados.mostrar"
               ref="modal_campos_personalizados"
               @hide="limpiarCamposPersonalizadosModal"
               :title="accionCamposPersonalizados + ' Campo personalizado'"
               centered
               hide-footer
      >
        <b-form @submit.prevent="validarFormulario"
                data-vv-scope="campos"
        >

          <b-form-group label="Nombre:"
                        label-for="nombre"
          >
            <b-form-input type="text"
                          id="nombre"
                          name="nombre"
                          v-model="selectedCamposPersonalizados.nombre"
                          data-vv-as=" "
                          v-validate="'required|min:3|max:255'"
                          style="text-transform: uppercase"
            />
            <span class="text-danger span-error small">{{ errors.first('campos.nombre') }}</span>
          </b-form-group>

          <!-- <b-form-group v-if="accionCamposPersonalizados === 'Actualizar'">
            <label class="w-100">
              Estado
            </label>
            <b-form-radio-group id="activo"
                                name="activo"
                                v-model="selectedCamposPersonalizados.activo"
                                :options="opciones"
                                :button-variant="selectedCamposPersonalizados.activo ? 'outline-primary' : 'outline-secondary'"
                                buttons
            />
          </b-form-group> -->
          <b-row>
            <b-col class="text-center">
              <hr>
              <b-button type="submit"
                        align="center"
                        variant="primary"
                        class="btn-sm"
              >
                <i class="fa fa-save"/>
                Guardar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <b-button @click="backRoute()"
                  size="sm"
                  variant="secondary"
                  class="float-left"
        >
          <i class="fa fa-reply fa-lg"></i>
          Volver
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import {cambiarEstado, guardaCampoPersonalizado} from '../../servicios/empresa/actions';
import {establecerSelectedCamposPersonalizados} from '../../servicios/empresa/mutations';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: 'empresa-campos-personalizados',
  data() {
    return {
      opciones: [
        {value: 1, text: 'Si'},
        {value: 0, text: 'No'}
      ],
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  computed: {
    ...mapState('empresa', [
      'selectedCamposPersonalizados',
      'listadoCamposPersonalizados',
      'opcionesPersonalizado',
      'modal_campos_personalizados',
      'accionCamposPersonalizados'
    ])
  },
  async mounted() {
    await this.getCamposPersonalizado(this.$route.params.id);
  },
  methods: {
    limpiarCamposPersonalizadosModal() {
      this.resetSelectedCamposPersonalizados();
    },
    ...mapActions('empresa', ['guardaCampoPersonalizado', 'getCamposPersonalizado', 'actualizaCamposPersonalizado', 'cambiarEstado']),
    ...mapMutations('empresa', ['establecerModalCamposPersonalizados', 'establecerAccionCamposPersonalizados', 'establecerSelectedCamposPersonalizados','resetSelectedCamposPersonalizados','resetCamposPersonalizados']),
    _mostrarModalCampos(accion = 'Crear') {
      this.establecerAccionCamposPersonalizados(accion);
      this.establecerModalCamposPersonalizados(true);
    },
    async _getCamposPersonalizado(campoPersonalizado) {
      this.establecerSelectedCamposPersonalizados(campoPersonalizado);
      this._mostrarModalCampos('Actualizar');
    },
    async _cambiarEstado(campoPersonalizado) {

      let tempCampoPersonalizado = JSON.parse(JSON.stringify(campoPersonalizado));

      tempCampoPersonalizado.activo = !tempCampoPersonalizado.activo;
      this.establecerSelectedCamposPersonalizados(tempCampoPersonalizado);
      this.establecerAccionCamposPersonalizados('Actualizar');
      await this.cambiarEstado();
    },
    async validarFormulario() {
      await this.$validator.validateAll('campos')
        .then(async (validado) => {
          if (validado) {
            if (this.accionCamposPersonalizados === 'Crear') {
              await this.guardaCampoPersonalizado();
            } else {
              await this.actualizaCamposPersonalizado();
            }
          }
        });
    },
    backRoute(){
        const currentPath = this.$route.path;
        if (currentPath.includes("/my-company")) {
            this.$router.go(-1);
        }else {
            this.$router.push("/empresas");
        }
    },
  },
};
</script>
